import { render, staticRenderFns } from "./ReleasesOtherIdsEditPanelDialog.vue?vue&type=template&id=b2f542fc"
import script from "./ReleasesOtherIdsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./ReleasesOtherIdsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports